import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import "./FieldStyles.css";
import InitialQuotationState from '../../InitialQuotationState'

var rex = /[\uFF10-\uFF19]/g;

class Dimensions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            widthEvent: null,
            // widthVal: this.props.selectedWidth,
            widthVal: "",
            lengthEvent: null,
            // lengthVal: this.props.selectedLength,
            lengthVal: "",
            dimensionErrorDiv: false

        };

        this.setWidthLength = this.setWidthLength.bind(this);
        this.onBlurDimensions = this.onBlurDimensions.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({
                widthVal: (Math.floor(this.props.pcbParams.width *10) / 10).toFixed(1),
                lengthVal: (Math.floor(this.props.pcbParams.length *10) /10).toFixed(1)
            })
        }
    }

    setWidthLength = (event) => {
        let regex = new RegExp(/^[1-9]([0-9]*)(\.[0-9]{0,2})?$/);

        if(!event.target.value.NaN) {
            this.setState({
                dimensionErrorDiv: false
            })
            let val2 = event.target.value;

            val2 = val2.replace(rex, function (ch) {
                return String.fromCharCode(ch.charCodeAt(0) - 65248);
            });

            val2 = val2.replace(/\s/g, '');
            val2 = val2.replace(/\u3002/g, ".");

            if (event.target.name === "pcbWidth") {
                this.setState({
                    widthEvent: event,
                    widthVal: val2
                })
            } else {
                this.setState({
                    lengthEvent: event,
                    lengthVal: val2
                })
            }
        }else {
            this.setState({
                widthEvent: null,
                widthVal: 100.0,
                lengthEvent: null,
                lengthVal: 100.0
            })
        }
    };

    onBlurDimensions = (event) => {
        //
        // console.log("******************************************************************************");
        //
        // console.log("event234", event.target.value);
        // console.log("event234", event.target.name);
        // console.log("******************************************************************************");
        let regex = new RegExp(/^[1-9]([0-9]*)(\.[0-9]{1,2})?$/);
        let regGreater = /^[1-9]([0-9]*)(\.[0-9]{0,1})?$/;
        // let regexNumber = new RegExp('^[0-9]*$');
        let val2 = event.target.value;

        val2 = val2.replace(rex, function (ch) {
            return String.fromCharCode(ch.charCodeAt(0) - 65248);
        });

        val2 = val2.replace(/\s/g, '');
        val2 = val2.replace(/\u3002/g, ".");
        let maxVal;
        let minVal = 6;
        // if (event.target.name === "pcbWidth") {
        //     maxVal = 400;
        //     console.log("target val if==> " + this.state.lengthVal);
        // } else {
        //     maxVal = 500;
        // }

        if (this.state.lengthVal === 500 || this.state.widthVal === 500) {
                maxVal = 400;
        } else {
            maxVal = 500;
            }
//

        if (val2 < 100) {
            if (regex.test(val2)) {
                if (val2 <= maxVal) {
                    if(val2 >= minVal){
                        this.props.setDimensions(event);
                    }else {
                        this.setState({
                            dimensionErrorDiv: true
                        })
                        setTimeout(()=>{
                            this.setState({
                                dimensionErrorDiv: false
                            })
                        },5000)
                        this.setState({
                            widthVal: this.props.selectedWidth,
                            lengthVal: this.props.selectedLength
                        })
                    }


                } else {
                    this.setState({
                        dimensionErrorDiv: true
                    })
                    setTimeout(()=>{
                        this.setState({
                            dimensionErrorDiv: false
                        })
                    },5000)
                    this.setState({
                        widthVal: this.props.selectedWidth,
                        lengthVal: this.props.selectedLength
                    })
                }


            } else {
                this.setState({
                    widthVal: this.props.selectedWidth,
                    lengthVal: this.props.selectedLength
                })
            }
        } else {
            if (regGreater.test(val2)) {
                if (val2 <= maxVal) {
                    if(val2 >= minVal){
                        this.props.setDimensions(event);
                    }else {
                        this.setState({
                            dimensionErrorDiv: true
                        })
                        setTimeout(()=>{
                            this.setState({
                                dimensionErrorDiv: false
                            })
                        },5000)
                        this.setState({
                            widthVal: this.props.selectedWidth,
                            lengthVal: this.props.selectedLength
                        })
                    }


                } else {
                    this.setState({
                        dimensionErrorDiv: true
                    })
                    setTimeout(()=>{
                        this.setState({
                            dimensionErrorDiv: false
                        })
                    },5000)
                    this.setState({
                        widthVal: this.props.selectedWidth,
                        lengthVal: this.props.selectedLength
                    })
                }


            } else {
                this.setState({
                    widthVal: this.props.selectedWidth,
                    lengthVal: this.props.selectedLength
                })
            }
        }


        // this.props.setDimensions(event);
    };

    render() {

        return (
            <div className="row">
                <div className="col-md-12 no-padding">
                    <div className="pcb-details-div">
                        <div className="">
                            <div className="col-md-3 text-right content-item-heading">
                                <FormattedMessage id="app.pcb-quotation.pcb-dimensions"
                                                  defaultMessage="Dimensions"
                                                  description=""
                                />
                                &nbsp; &nbsp;
                                <Link id="dimension-qLink"
                                    to={{pathname:"https://kitcutlabo.com/pcb-thickness/"}} target="_self"
                                    className="glyphicon glyphicon-question-sign question-link"></Link>
                            </div>
                            <div className="col-md-9 pcb-dimension">
                                <div className="col-md-2 custom-col-2 pcb-details-div-items ">

                                    {InitialQuotationState.gerberImageData.id === -1 || this.state.widthVal !== null  ?
                                        <input type="text" name="pcbWidth" id="pcbWidth" readOnly={false} value={this.state.widthVal}
                                               onChange={this.setWidthLength}
                                               onBlur={this.onBlurDimensions}
                                               className="form-control input-sm dimensions-input"/>
                                        :
                                        <input type="text" name="pcbWidth" id="pcbWidth" readOnly={true} value={this.state.widthVal}
                                               onChange={this.setWidthLength}
                                               onBlur={this.onBlurDimensions}
                                               className="form-control input-sm dimensions-input"/>

                                    }
                                    {/*<input type="text" name="pcbWidth" readOnly={true} value={props.selectedWidth}*/}
                                    {/*onChange={props.setDimensions}*/}
                                    {/*className="form-control input-sm dimensions-input"/>*/}
                                </div>
                                <div className="col-md-1 custom-col-1 multiply-div text-center">
                                    x
                                </div>
                                <div className="col-md-2 custom-col-2 pcb-details-div-items ">

                                    {InitialQuotationState.gerberImageData.id === -1 || this.state.lengthVal !== null ?

                                        <input type="text" name="pcbLength" id="pcbLength" readOnly={false}
                                               value={this.state.lengthVal}
                                               onChange={this.setWidthLength}
                                               onBlur={this.onBlurDimensions}
                                               className="form-control input-sm dimensions-input"/>
                                        :
                                        <input type="text" name="pcbLength" id="pcbLength" readOnly={true} value={this.state.lengthVal}
                                               onChange={this.setWidthLength}
                                               onBlur={this.onBlurDimensions}
                                               className="form-control input-sm dimensions-input"/>
                                    }
                                </div>
                                <div className="col-md-2 custom-col-2 pcb-details-div-items-dimension">
                                    mm
                                </div>

                            </div>
                            {this.state.dimensionErrorDiv ? <div>
                                    <div className='col-md-3'></div>
                                    <div className="col-md-9 error-text-pcb-quotation">※最小製造寸法 6mm×6mm 最大製造寸法 400mm×500mm。</div>
                                </div>
                                :
                                ""
                            }

                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default Dimensions;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBQuotationFormFields/Dimensions.js